import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card, Button, Tab, Nav } from "react-bootstrap";
// import 'bootstrap/dist/css/bootstrap.min.css';
import "./EssDashboard.css";
import WelcomeCard from "./WelcomeCard";
import { HolidayCard } from "./HolidayCard";
import { LeaveBalanceCard } from "./LeaveBalanceCard";
import { OnLeaveCard } from "./OnLeaveCard";
import { EventsCard } from "./EventsCard";
import { AnnouncementsCard } from "./AnnouncementsCard";
import { EssDasbaord } from "../../../api/Ess/Dasboard";

const EssDashboard = () => {
  const user = JSON.parse(localStorage.getItem("school_user"));
  const { user_detail } = user || {};
  const [dashboard, setDashboard] = useState([]);

function getAttendanceMonth() {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    return `${year}-${month}`;
}



  const getEssDashboardData = async () => {
    let data = {
      school_id: user_detail?.fk_school_id,
      staff_id: user_detail.staff_id,
      attendance_month: getAttendanceMonth(),
    };

    try {
      const response = await EssDasbaord.Dashboard_ESS(data);
      if (response.status === 200) {
        setDashboard(response.data);
      }
    } catch (err) {
    } finally {
    }
  };
// {
//     "status": true,
//     "holidays": [
//         {
//             "start_date": "2025-01-26",
//             "end_date": "2025-08-26",
//             "is_holiday": true,
//             "holiday_name": "Republic Day",
//             "holiday_type": "Government Holiday"
//         },
//         {
//             "start_date": "2025-08-11",
//             "end_date": "2025-08-11",
//             "is_holiday": true,
//             "holiday_name": "Dussehra (Vijayadashami)",
//             "holiday_type": "Government Holiday"
//         },
//         {
//             "start_date": "2025-08-15",
//             "end_date": "2025-08-15",
//             "is_holiday": true,
//             "holiday_name": "Independence Day",
//             "holiday_type": "Government Holiday"
//         },
//         {
//             "start_date": "2025-09-02",
//             "end_date": "2025-09-02",
//             "is_holiday": true,
//             "holiday_name": "Ganesh Chaturthi",
//             "holiday_type": "Government Holiday"
//         },
//         {
//             "start_date": "2025-10-02",
//             "end_date": "2025-10-02",
//             "is_holiday": true,
//             "holiday_name": "Gandhi Jayanti",
//             "holiday_type": "Government Holiday"
//         },
//         {
//             "start_date": "2025-10-31",
//             "end_date": "2025-11-04",
//             "is_holiday": true,
//             "holiday_name": "Diwali",
//             "holiday_type": "Government Holiday"
//         }
//     ],
//     "on_leave_today": [
//         {
//             "fk_staff__id": 18,
//             "fk_staff__first_name": "Fredric",
//             "fk_staff__last_name": "Frances",
//             "fk_staff__fk_designation__name": "designation",
//             "leave_date": "2025-08-07",
//             "reason": "Something Urgent"
//         }
//     ],
//     "new_joiners": [
//         {
//             "first_name": "John",
//             "last_name": "Doe",
//             "date": "2025-08-05",
//             "fk_designation__name": "designation"
//         },
//         {
//             "first_name": "Rohit",
//             "last_name": "sharma",
//             "date": "2025-08-05",
//             "fk_designation__name": "designation"
//         }
//     ],
//     "birthdays_today": [
//         {
//             "first_name": "Rohit",
//             "last_name": "sharma",
//             "date": "2002-08-07",
//             "fk_designation__name": "designation"
//         }
//     ],
//     "upcoming_birthdays": [
//         {
//             "first_name": "John",
//             "last_name": "Doe",
//             "date": "2002-08-10",
//             "designation": "designation"
//         }
//     ],
//     "anniversaries_today": [],
//     "announcements": [],
//     "leave_balance": {
//         "total_leaves": 65,
//         "leaves_taken": 0,
//         "leaves_remaining": 65
//     }
// }

  useEffect(() => {
    getEssDashboardData()
  }, []);


  console.log(dashboard ,"<><><><><,.,.,.,><><><><,.,.,.,.<><><><><,.,.,.,.,<><><><><>,.,.,.,.<>><><><<")

  return (
    <div class="p-2">
      <WelcomeCard data={user_detail}/>
      <div className="row">
        <div class="col-12 col-md-6 col-lg-6">
          <HolidayCard  holidays={dashboard?.holidays || []}/>
        </div>
        <div class="col-12 col-md-6 col-lg-6">
          <LeaveBalanceCard  leavebalance={dashboard?.leave_balance}/>
        </div>
        <div class="col-12 col-md-6 col-lg-6 mt-2">
          <OnLeaveCard  onLeaveData={dashboard?.on_leave_today || []}/>
        </div>
        <div class="col-12 col-md-6 col-lg-6 mt-2">
          <EventsCard  data={dashboard}/>
        </div>
        <div class="col-12 col-md-6 col-lg-6 mt-2">
          {/* <AnnouncementsCard /> */}
        </div>
      </div>
    </div>
  );
};

export default EssDashboard;


